import React, { useState, useEffect } from 'react';
import './FilterAvaliacao.css';
import Select from 'react-select';
import { fetchGroupers } from '../../services/api/fetchGrouper';
import { fetchClientSubjects } from '../../services/api/fetchGrouper';
import InputMask from 'react-input-mask';

function FilterAvaliacao({ clientId, clippingId, onClose, onAddFilter, loadExistingData }) {
  const [groupers, setGroupers] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const getGroupers = async () => {
      try {
        const response = await fetchGroupers(clientId);
        const sortedGroupers = response.sort((a, b) => a.id - b.id);
        setGroupers(sortedGroupers);

        if (loadExistingData) {
          const evaluationData = await fetchGroupers(clientId);
          const initialValues = {};
          evaluationData.forEach(item => {
            if (clippingId.includes(item.id)) {
              initialValues[item.id] = item.value;
            }
          });
          setSelectedValues(initialValues);
        }

        const fetchedSubjects = await fetchClientSubjects(clientId);
        setSubjects(fetchedSubjects.subjects || []);

        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar groupers:', error);
        setLoading(false);
      }
    };

    getGroupers();
  }, [clientId, clippingId, loadExistingData]);

  const handleInputChange = (id, value) => {
    setSelectedValues({
      ...selectedValues,
      [id]: value
    });
  };

  const handleAddFilter = () => {
    const filterData = groupers.map(grouper => ({
      grouper_detail: { id: grouper.id, name: grouper.name },
      value: selectedValues[grouper.id] || ''
    }));

    onAddFilter(filterData);
    onClose();
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      padding: '10px',
      fontSize: '14px',
      borderColor: state.isFocused ? '#ccc' : '#ccc',
      borderRadius: '4px',
      backgroundColor: 'white',
      color: '#333',
      outline: 'none',
      boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none',
      transition: 'border-color 0.3s, box-shadow 0.3s',
      '&:hover': {
        borderColor: '#ccc',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#eee' : '#fff',
      color: '#333',
      padding: '10px',
      '&:active': {
        backgroundColor: '#eee',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 2,
    }),
  };

  if (loading) {
    return null;
  }

  return (
    <section className="container_avaliacao-filter-avaliacao">
      <button className="close-button_avaliacao-filter-avaliacao" aria-label="Close" onClick={onClose}>x</button>
      <h1 className="title_avaliacao-filter-avaliacao">Avaliação</h1>
      <hr className='hr-filter-avaliacao'></hr>

      <div className="grid_avaliacao-filter-avaliacao">
        {groupers.map(grouper => (
          <div key={grouper.id} className="date-picker-filters-avaliacao-filter-avaliacao">
            <div className="date-picker-label-filters-avaliacao-filter-avaliacao">{grouper.name}</div>
            {grouper.field_type === 'select' && (
              <Select
                styles={customStyles}
                value={selectedValues[grouper.id] ? { value: selectedValues[grouper.id], label: selectedValues[grouper.id] } : null}
                onChange={(selectedOption) => handleInputChange(grouper.id, selectedOption ? selectedOption.value : '')}
                options={grouper.values_list.map(option => ({
                  value: option.value,
                  label: option.value
                }))}
                placeholder="Todas"
              />
            )}
            {grouper.field_type === 'radio' && (
              grouper.values_list.map((option, index) => (
                <div key={index} className="feature_avaliacao-filter-avaliacao">
                  <input
                    type="radio"
                    id={`${grouper.id}-${index}`}
                    name={`feature-${grouper.id}`}
                    value={option.value}
                    className="radio-item_avaliacao-filter-avaliacao"
                    checked={selectedValues[grouper.id] === option.value}
                    onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                  />
                  <label htmlFor={`${grouper.id}-${index}`} className="feature-label_avaliacao-filter-avaliacao">
                    {option.value}
                  </label>
                </div>
              ))
            )}
              {grouper.field_type === 'number' && (
                <div className="input-wrapper">
                  {selectedValues[grouper.id] && <span className="currency-prefix">R$</span>}
                  <input
                    type="number"
                    className="custom-select-tema-filter-avaliacao"
                    placeholder="Digite a valoração"
                    value={selectedValues[grouper.id] || ''}
                    onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                    style={{ paddingLeft: selectedValues[grouper.id] ? '2rem' : '0.5rem' }}
                  />
                </div>
              )}
            {grouper.field_type === 'text' && grouper.name === 'Assunto' && (
                  <div style={{ position: 'relative', display: 'inline-block', width: '100%'}}>
                    <input
                      type="text"
                      className="custom-select-tema-filter-avaliacao"
                      placeholder="Digite ou selecione um assunto"
                      value={selectedValues[grouper.id] || ''}
                      onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                      onFocus={() => setDropdownOpen(true)}
                      onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
                    />
                    {dropdownOpen && (
                      <ul
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          minWidth: '168px',
                          maxHeight: '170px',
                          overflowY: 'auto',
                          backgroundColor: 'white',
                          border: '1px solid #ccc',
                          zIndex: 1000,
                          listStyle: 'none',
                          marginTop: -17,
                          padding: '5px 0',
                          borderRadius: '5px',
                        }}
                      >
                        {subjects
                          .filter((subject) =>
                            subject.toLowerCase().includes((selectedValues[grouper.id] || '').toLowerCase())
                          )
                          .map((subject, index) => (
                            <li
                              key={index}
                              style={{
                                padding: '5px 10px',
                                cursor: 'pointer',
                                backgroundColor:
                                  subject === selectedValues[grouper.id] ? '#121926' : 'white',
                                color: subject === selectedValues[grouper.id] ? 'white' : '#121926',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#121926';
                                e.currentTarget.style.color = 'white';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = subject === selectedValues[grouper.id] ? '#121926' : 'white';
                                e.currentTarget.style.color = subject === selectedValues[grouper.id] ? 'white' : 'black';
                              }}
                              onMouseDown={() => handleInputChange(grouper.id, subject)}
                            >
                              {subject}
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                )}
                {grouper.field_type === 'text' && grouper.name !== 'Assunto' && (
                  <input
                    type="text"
                    className="custom-select-tema-filter-avaliacao"
                    placeholder="Texto"
                    value={selectedValues[grouper.id] || ''}
                    onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                  />
                )}
          </div>
        ))}
      </div>

      {message && <p className="success-message-filter-avaliacao">{message}</p>}
      {error && <p className="error-message-filter-avaliacao">{error}</p>}

      <button className="block-rate_avaliacao-filter-avaliacao" aria-label="Avaliar noticias em bloco" onClick={handleAddFilter}>
        Adicionar filtros de avaliação
      </button>
      <button className="cancel-button_avaliacao-filter-avaliacao" aria-label="Cancelar" onClick={onClose}>
        Cancelar
      </button>
    </section>
  );
}

export default FilterAvaliacao;
